import { useMemo } from "react";

import Link from "ds/components/Link";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { encodeApiKeyId } from "shared/ApiKey/urlHelpers";

import { CellComponentProps, EntityType } from "../types";

type RoleUsedByListItemNameCellProps = CellComponentProps;

const RoleUsedByListItemNameCell = ({ entity }: RoleUsedByListItemNameCellProps) => {
  const entityUrl = useMemo(() => {
    switch (entity.type) {
      case EntityType.User:
        return `/settings/user/${entity.id}`;
      case EntityType.UserGroup:
        return `/settings/idp-group/${entity.id}`;
      case EntityType.ApiKey:
        return `/settings/api-key/${encodeApiKeyId(entity.id)}`;
      case EntityType.Stack:
        return `/stack/${entity.id}`;
    }
  }, [entity.type, entity.id]);

  return (
    <Link
      analyticsPage={AnalyticsPageOrganization.OrganizationRoleUsedBy}
      analyticsTitle="Entity Name Clicked"
      analyticsProps={{
        roleName: entity.name,
      }}
      size="small"
      variant="secondary"
      href={entityUrl}
    >
      {entity.name}
    </Link>
  );
};

export default RoleUsedByListItemNameCell;
